import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

type ServiceAgreementInfoData = {
  lenderServiceAgreementParty: { name: string };
  borrowerServiceAgreementParty: { name: string };
  workerPoolSize: number;
  flexPoolCount: number;
};

export const LenderServiceAgreementInfo = ({ data }: { data: ServiceAgreementInfoData }) => {
  const { t } = useTranslation('all-platforms-common');

  return (
    <ServiceAgreementInfoGrid
      partyLabel={t('service-agreement.borrower')}
      partyName={data.borrowerServiceAgreementParty.name}
      workerPoolSize={data.workerPoolSize}
      flexPoolCount={data.flexPoolCount}
    />
  );
};

export const BorrowerServiceAgreementInfo = ({ data }: { data: ServiceAgreementInfoData }) => {
  const { t } = useTranslation('all-platforms-common');

  return (
    <ServiceAgreementInfoGrid
      partyLabel={t('service-agreement.lender')}
      partyName={data.lenderServiceAgreementParty.name}
      workerPoolSize={data.workerPoolSize}
      flexPoolCount={data.flexPoolCount}
    />
  );
};

const ServiceAgreementInfoGrid = ({
  partyLabel,
  partyName,
  workerPoolSize,
  flexPoolCount,
}: {
  partyLabel: string;
  partyName: string;
  workerPoolSize: number;
  flexPoolCount: number;
}) => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Grid item container spacing={3} xs={8}>
      <Grid item xs={6}>
        <Typography variant="subtitle1">{partyLabel}</Typography>
        <Typography variant="body2">{partyName}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">{t('service-agreement.worker_pool_size')}</Typography>
        <Typography variant="body2">{workerPoolSize}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">{t('service-agreement.start_date')}</Typography>
        <Typography variant="body2">{DateTime.now().toFormat('yyyy-MM-dd')}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">{t('service-agreement.flexpool_count')}</Typography>
        <Typography variant="body2">{flexPoolCount}</Typography>
      </Grid>
    </Grid>
  );
};
